'use client';

import React from 'react';
import styles from './AccountContactForm.module.scss';
import { DynamicForm } from '@/components/forms/dynamic-form/DynamicForm';
import { createSchema, IAPIFormSchema } from '@/services/formSchema.service';
import { useTranslation } from '@app/i18n/useTranslationClient';
import { IContactFormSchemaResponse } from '@/hooks/api/fetchContactFormSchema/useContactFormSchema.interfaces';
import { FieldValues, UseFormReset, UseFormSetError } from 'react-hook-form';
import { handleFormServerErrors } from '@/components/dynamic-field/field-input/fieldInput.helper';
import { useContact } from '@/hooks/api/useContact/useContact';
import { IContactRequest } from '@/hooks/api/useContact/useContact.interfaces';
import { Modal } from '@/components/modal/Modal';
import { AdditionalInfoElement } from '@/components/dynamic-field/field-additional-info/AdditionalInfoElement';

export interface IAccountContactForm {
    contactResponse: IContactFormSchemaResponse;
}
export const AccountContactForm: React.FC<IAccountContactForm> = ({ contactResponse }) => {
    const [isFormSubmitted, setSubmitForm] = React.useState(false);
    const contactInquiryAdministratorInfo = AdditionalInfoElement(contactResponse.contactInquiryAdministratorInfo);

    const {
        t,
        i18n: { language },
    } = useTranslation();

    const { sendContactForm, loading } = useContact();

    const contactSchema = createSchema(contactResponse as unknown as IAPIFormSchema, language, t);

    const onFormSubmit = async (data: FieldValues, setErrors: UseFormSetError<any>, reset: UseFormReset<any>) => {
        const response = await sendContactForm(data as IContactRequest);

        if (response.errors) {
            handleFormServerErrors(setErrors, response.errors);
        } else {
            reset();
            setSubmitForm(true);
        }
    };

    const handleCloseModal = () => setSubmitForm(false);

    if (isFormSubmitted) {
        return (
            <Modal isClosable={true} classes={styles.modal} onClose={handleCloseModal}>
                {t('translations.account.contact.formSendSuccessfully')}
            </Modal>
        );
    }

    return (
        <DynamicForm
            formSchema={contactSchema}
            formSubmitButtonLabel={t('translations.forms.send')}
            element={contactInquiryAdministratorInfo}
            isSubmitButtonDisabled={loading}
            onFormSubmit={onFormSubmit}
        />
    );
};
